import { LOCAL_STORAGE } from "@app/constants/local-storage";

import JWT from "./jwt";
import {
  OutPublicUserWithDataWarehouseProductsDTO,
  OutPublicUserWithTokenDTO,
  PublicAuthApi,
  PublicUsersApi
} from "@app/bf-api";

const getJWT = async (): Promise<string | undefined> => {
  const jwt = JWT.get();

  if (!jwt) {
    localStorage.removeItem(LOCAL_STORAGE.JWT);

    return;
  }

  return jwt;
};

const requestLogin = async (email: string, platformId: number, eanToLike?: string): Promise<boolean> => {
  try {
    const api = new PublicAuthApi();
    await api.publicLogin({ publicLoginDTO: { email, platformId, eanToLike } });
    return true;
  } catch {
    return false;
  }
};

const login = async (jwt: string): Promise<OutPublicUserWithTokenDTO | undefined> => {
  try {
    const api = new PublicAuthApi();
    const newJwt = await api.callback({ token: jwt });

    localStorage.removeItem(LOCAL_STORAGE.JWT);
    localStorage.setItem(LOCAL_STORAGE.JWT, newJwt.publicToken);

    return newJwt;
  } catch {
    return undefined;
  }
};

const getMe = async (jwt: string): Promise<OutPublicUserWithDataWarehouseProductsDTO | undefined> => {
  const api = new PublicUsersApi();
  const user = await api.getMe({ xAccessToken: jwt });
  return user;
};

const logout = () => {
  localStorage.removeItem(LOCAL_STORAGE.JWT);
};

const Authenticate = {
  getJWT,
  login,
  logout,
  requestLogin,
  getMe
};

export { Authenticate };
